import colors from "@/config/colors";

export default class MerchSliderDesktop {
	#sliderRoot;
	#sliderList;
	#sourceList;
	#tallestCard;
	#slidesShown;
	#leftBtn;
	#rightBtn;
	#cards;
	#slidesShownConfig = {
		desktop: 4,
		tablet: 3,
		mobile: 0,
	};

	constructor(sliderRoot) {
		this.#sliderRoot = sliderRoot;
	}

	// getters

	get sliderRoot() {
		return this.#sliderRoot;
	}

	// private methods

	#getTemplate() {
		return `
        
            <div class="position-relative d-flex justify-content-center">
                <button
                    class="merchandising-slider-btn-desktop cursor-pointer position-absolute left justify-content-center align-items-center ts-arrow-left bg-none"
                >
                </button>
            </div>

            <div class="merchandising-slider-desktop">
                <div class="merchandising-slider-list d-none d-md-flex flex-md-row nowrap"></div>
            </div>

            <div class="position-relative d-flex justify-content-center">
                <button
                    class="merchandising-slider-btn-desktop cursor-pointer position-absolute right justify-content-center align-items-center ts-arrow-right bg-none"
                >
                </button>
            </div>

        `;
	}

	#getSlidesShown() {
		if (window.screenSizeManager.screenType === "desktop")
			return this.#slidesShownConfig["desktop"];
		if (window.screenSizeManager.screenType === "tablet")
			return this.#slidesShownConfig["tablet"];
		return this.#slidesShownConfig["mobile"];
	}
	#getTallestCard() {
		let tallestCardIndex = 0;
		let tallestCardHeight = 0;
		this.#cards.forEach((card, card_i) => {
			const cardHeight = card.getBoundingClientRect().height;
			if (cardHeight > tallestCardHeight) {
				tallestCardHeight = cardHeight;
				tallestCardIndex = card_i;
			}
		});
		return this.#cards[tallestCardIndex];
	}
	#getAnyCard() {
		return this.#sliderList.firstElementChild;
	}
	#getCardWidth() {
		return (
			this.#sliderRoot
				.querySelector(".merchandising-slider-desktop")
				.getBoundingClientRect().width / this.#slidesShown
		);
	}
	#getCardHeight() {
		return this.#tallestCard.getBoundingClientRect().height;
	}
	#getCurrentCardNo() {
		return Math.round(
			(-1 * parseFloat(window.getComputedStyle(this.#sliderList).left)) /
				this.#getCardWidth()
		);
	}
	#getSliderListLength() {
		return this.#sliderList.children.length;
	}
	#getCards() {
		return Array.from(this.#sliderList.children);
	}
	#getAnyImg() {
		return this.#sliderRoot.querySelector(".tf-merchandising-item img");
	}

	#adjustSliderBtnPosition() {
		const imgHeight = this.#getAnyImg().getBoundingClientRect().height;
		const btnHeight = this.#leftBtn.getBoundingClientRect().height;
		this.#leftBtn.style.top = `${imgHeight / 2 - btnHeight / 2}px`;
		this.#rightBtn.style.top = `${imgHeight / 2 - btnHeight / 2}px`;
	}

	#adjustImageWidth() {
		this.#cards.forEach((card) => {
			card.style.width = `${this.#getCardWidth()}px`;
		});
	}

	#adjustSliderRootHeight() {
		this.#sliderRoot.querySelector(
			".merchandising-slider-desktop"
		).style.height = `${this.#getCardHeight()}px`;
		this.#sliderRoot.querySelector(
			".merchandising-slider-desktop"
		).style.maxHeight = `${this.#getCardHeight()}px`;
	}

	#getNextImgNo(currentNo, direction) {
		if (direction === "left") {
			const preliminaryToImage = currentNo - 1;
			let newImgNo = preliminaryToImage;
			if (preliminaryToImage < 0) {
				newImgNo = this.#getSliderListLength() - this.#slidesShown;
			}
			return newImgNo;
		} else if (direction === "right") {
			const preliminaryToImage = currentNo + 1;
			let newImgNo = preliminaryToImage;
			if (
				preliminaryToImage + this.#slidesShown >
				this.#getSliderListLength()
			) {
				newImgNo = 0;
			}
			return newImgNo;
		}
	}

	#animateToCard(toImage_No) {
		this.#sliderList.style.left = `-${
			parseFloat(this.#getCardWidth()) * toImage_No
		}px`;
	}

	#initializeWidthAndHeightAdjustmentListener() {
		// This throttles the event listener. Responding to each resize event is awful for performance. Instead it responds only every fixed period of time (200ms)
		const adjustWidth = () => {
			window.removeEventListener("resize", adjustWidth);
			this.makeAdjustments();
			setTimeout(() => {
				window.addEventListener("resize", adjustWidth, { passive: true });
			}, 100);
		};
		window.addEventListener("resize", adjustWidth);
	}

	#injectHTML() {
		this.#sliderRoot.innerHTML = "";
		this.#sliderRoot.insertAdjacentHTML("beforeend", this.#getTemplate());
	}

	#appendInitialCards() {
		Array.from(this.#sourceList.children).forEach((card) => {
			const clone = card.cloneNode(true);
			this.#sliderList.appendChild(clone);
		});
	}

	#setStyles() {
		this.#sliderRoot.querySelector(
			".merchandising-slider-desktop"
		).style.position = "relative";
		this.#sliderRoot.querySelector(
			".merchandising-slider-desktop"
		).style.overflowX = "hidden";
		this.#sliderList.style.position = "absolute";
		this.#sliderList.style.left = "0px";

		// hide controls if total cards fewer or equal to shown cards number
		if (this.#cards.length <= this.#slidesShown) {
			this.#leftBtn.style.display = "none";
			this.#rightBtn.style.display = "none";
		}
	}

	#setListeners() {
		this.#initializeWidthAndHeightAdjustmentListener();

		this.#leftBtn.addEventListener("click", () => this.triggerSlide("left"));
		this.#rightBtn.addEventListener("click", () => this.triggerSlide("right"));

		Array.from(this.#getAnyCard().querySelectorAll("img")).forEach((img) => {
			img.addEventListener("load", () => {
				this.makeAdjustments();
			});
		});
	}

	#hideControlButtonsIfNeeded() {
		if (this.#cards.length <= this.#slidesShown) {
			this.#leftBtn.style.display = "none";
			this.#rightBtn.style.display = "none";
		}
	}

	#hideSourceListOnDesktop() {
		// this.#sourceList.classList.add('d-md-none')
		this.#sourceList.remove();
	}

	// public methods

	makeAdjustments() {
		this.#adjustImageWidth();
		this.#adjustSliderRootHeight();
		this.#adjustSliderBtnPosition();
		this.#hideControlButtonsIfNeeded();
	}

	init() {
		this.#injectHTML();

		this.#sliderList = this.#sliderRoot.querySelector(
			".merchandising-slider-list"
		);
		this.#sourceList = this.#sliderRoot.parentElement.querySelector(
			".tf-merchandising-item-list"
		);
		this.#leftBtn = this.#sliderRoot.querySelector(
			`.merchandising-slider-btn-desktop.left`
		);
		this.#rightBtn = this.#sliderRoot.querySelector(
			`.merchandising-slider-btn-desktop.right`
		);
		this.#slidesShown = this.#getSlidesShown();

		this.#appendInitialCards();

		this.#cards = Array.from(
			this.#sliderRoot.querySelector(".merchandising-slider-list").children
		);
		this.#tallestCard = this.#getTallestCard();

		this.#setListeners();
		this.#setStyles();
		this.makeAdjustments();
		this.#hideSourceListOnDesktop();

		// kinda hotfix, but I dont know why the heights arent correct instantly
		setTimeout(() => {
			this.makeAdjustments();
		}, 1000);
		setTimeout(() => {
			this.makeAdjustments();
		}, 5000);
	}

	triggerSlide(direction) {
		const toImage_No = this.#getNextImgNo(this.#getCurrentCardNo(), direction);
		this.#animateToCard(toImage_No);
	}
}
